module.exports = __webpack_public_path__ + "static/media/logo.310f9b3d.png";